import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(date) {
  if (!date) return '-';
  return new Date(date).toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function formatDateTime(date) {
  if (!date) return '-';
  return new Date(date).toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
  }).format(amount || 0);
}

export function getStatusColor(status) {
  const colors = {
    pending: 'bg-amber-100 text-amber-800',
    in_progress: 'bg-blue-100 text-blue-800',
    completed: 'bg-emerald-100 text-emerald-800',
    cancelled: 'bg-red-100 text-red-800',
    admitted: 'bg-blue-100 text-blue-800',
    discharged: 'bg-slate-100 text-slate-800',
    active: 'bg-emerald-100 text-emerald-800',
    dispensed: 'bg-violet-100 text-violet-800',
    paid: 'bg-emerald-100 text-emerald-800',
    partial: 'bg-amber-100 text-amber-800',
  };
  return colors[status] || 'bg-slate-100 text-slate-800';
}

export function getRoleDisplayName(role) {
  const names = {
    super_admin: 'Super Admin',
    admin: 'Admin',
    doctor: 'Doctor',
    nurse: 'Nurse',
    receptionist: 'Receptionist',
    lab_technician: 'Lab Technician',
    pharmacist: 'Pharmacist',
    stockist: 'Stockist',
  };
  return names[role] || role;
}

export function calculateAge(dateOfBirth) {
  if (!dateOfBirth) return '-';
  const today = new Date();
  const birthDate = new Date(dateOfBirth);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

/** Human-readable message from an axios error (handles FastAPI 422 detail arrays). */
export function apiErrorMessage(error, fallback = 'Something went wrong') {
  const detail = error?.response?.data?.detail;
  if (Array.isArray(detail)) {
    const msgs = detail.map((d) => (typeof d === 'string' ? d : d?.msg || '')).filter(Boolean);
    return [...new Set(msgs)].join('. ') || fallback;
  }
  if (detail && typeof detail === 'object') return detail.message || JSON.stringify(detail);
  return detail || error?.message || fallback;
}
